<template>
  <Fragment>
    <li>
      <span>
        Fáze:
      </span>
    </li>
    <li v-if="phases && phases.length" class="dropdown">
      <a href="#" class="nolink">{{
        phases.find((i) => i.phaseId === phaseId).name
      }}</a>
      <Dropdown :items="phases" :bind-key="'phaseId'">
        <template v-slot:item="{ item }">
          <a :href="item.url" :title="`Otevřít fázi ${item.name}`">
            {{ item.name }}
          </a>
        </template>
      </Dropdown>
    </li>
    <li>
      <span>
        Oblast:
      </span>
    </li>
    <li v-if="areas[phaseId] && areas[phaseId].length" class="dropdown">
      <a href="#" class="nolink">{{
        areas[phaseId].find((i) => i.areaId === areaId).name
      }}</a>
      <Dropdown :items="areas[phaseId]" :bind-key="'areaId'">
        <template v-slot:item="{ item }">
          <a :href="item.url" :title="`Otevřít oblast ${item.name}`">
            {{ item.name }}
          </a>
        </template>
      </Dropdown>
    </li>
  </Fragment>
</template>
<script>
import { Fragment } from 'vue-fragment';
import Dropdown from '@/components/menu/Dropdown.vue';

export default {
  props: ['phases', 'areas', 'phaseId', 'areaId'],
  components: {
    Dropdown,
    Fragment
  }
};
</script>
<style scoped>
li span {
  font-family: 'Titillium Web', sans-serif;
  font-style: italic;
  padding-right: 0;
  color: #697681;

  margin-right: -1rem;
}
</style>
